import React, { useMemo, useState, useEffect, useContext } from 'react';
import { useLocalization } from 'localization/useLocalization';
import { SelectableColumn } from '../SelectableColumn';
import { QuickFilter } from '../NoahDeviceReadOutsList';
import { createColumnRecord } from '../utils/createColumnRecord';
import { createHeaders } from '../utils/createHeaders';
import { createQfRecord } from '../utils/createQfRecord';
import { createStatusRecord } from '../utils/createStatusRecord';
import { ViewContext } from './ViewContext';
import { QueryContext } from './QueryContext';
import { RecordContext } from 'shared/records/RecordContext';
import { NoahDeviceReadOutStatus } from 'gen/ApiClient';
import { onResetToPage1 } from 'framework/types/onResetToPage1';
import { useParamsFromQueryContext } from 'framework/hooks/useParamsFromQueryContext';

// enkel hier nodig
const DefaultColumns: SelectableColumn[] = ['uniqueField', 'formattedManufacturerCommaModelFromProductCatalogs', 'lastReadOutDate'];

const quickFilterToReadOutRecord: Record<QuickFilter, NoahDeviceReadOutStatus | undefined> = {
	all: undefined,
	linkedToMultiple: 'LinkedToMultiple',
	notLinkedNotIgnored: 'NotLinked',
};

export const ViewProvider = ({ children }: any) => {
	const { noahDeviceTypeRecord } = useContext(RecordContext);
	const strings = useLocalization();
	const [qf, setQf] = useState<QuickFilter>('all');
	const [columns, setColumns] = useState<SelectableColumn[]>(DefaultColumns);
	const colRecord = useMemo(() => createColumnRecord(strings), [strings]);
	const statusRecord = useMemo(() => createStatusRecord(strings), [strings]);
	const headers = useMemo(() => createHeaders(colRecord, strings, noahDeviceTypeRecord), [colRecord, strings, noahDeviceTypeRecord]);
	const quickFilterRecord = useMemo(() => createQfRecord(strings), [strings]);
	const { setParams } = useParamsFromQueryContext(QueryContext);

	useEffect(() => {
		setParams(params =>
			onResetToPage1({
				...params,
				keyFilterStatus: quickFilterToReadOutRecord[qf],
				statuses: qf === 'all' ? params.statuses : [], //reset this
			})
		);
		// eslint-disable-next-line
	}, [qf]);

	return (
		<ViewContext.Provider
			value={{
				columns: columns,
				columnsRecord: colRecord,
				headers: headers,
				setColumns: setColumns,
				quickFilter: qf,
				setQuickFilter: setQf,
				quickFilterRecord: quickFilterRecord,
				statusRecord: statusRecord,
			}}>
			{children}
		</ViewContext.Provider>
	);
};
